import { z } from "zod/v4"
import { DocumentSnapshotLike } from "../firestore"

export const VrmAccountImageKind = z.enum(["Neutral", "Happy"])
export type VrmAccountImageKind = z.infer<typeof VrmAccountImageKind>

const IMAGE_WIDTH = 4089
const IMAGE_HEIGHT = 2556

export const jsonString = z.string().min(1).check(
  z.refine(v => { try { JSON.parse(v); return true } catch { return false } }, "有効なJSON文字列である必要があります"),
)

export const VrmAccountImageSettingDocument = z.object({
  kind: VrmAccountImageKind.default("Neutral").describe("撮影時の表情。Neutral=無表情, Happy=笑顔。"),
  quality: z.number().int().min(0).max(100).default(50).describe("WebP エンコード品質 (0〜100)。"),
  margin_left: z.number().int().min(0).max(IMAGE_WIDTH).optional().describe("左マージン (px)。"),
  margin_right: z.number().int().min(0).max(IMAGE_WIDTH).optional().describe("右マージン (px)。"),
  margin_top: z.number().int().min(0).max(IMAGE_HEIGHT).optional().describe("上マージン (px)。"),
  margin_bottom: z.number().int().min(0).max(IMAGE_HEIGHT).optional().describe("下マージン (px)。"),
  layout: jsonString.optional().describe("カスタムレイアウト定義 (JSON 文字列)。"),
})

export type VrmAccountImageSettingDocument = z.infer<typeof VrmAccountImageSettingDocument>

export class VrmAccountImageSettingDocuments {

  static readonly VRM_ACCOUNT_IMAGE_SETTING_ID = "vrm-account-image-setting"

  static readonly DEFAULT_KIND: VrmAccountImageKind = "Neutral"
  static readonly DEFAULT_QUALITY = 50
  static readonly IMAGE_WIDTH = IMAGE_WIDTH
  static readonly IMAGE_HEIGHT = IMAGE_HEIGHT

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): VrmAccountImageSettingDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }
    return VrmAccountImageSettingDocument.parse(data)
  }
}

export const UpdateVrmAccountImageSettingRequest = z.object({
  kind: VrmAccountImageKind.optional(),
  quality: z.coerce.number().int().min(0).max(100).optional(),
  marginLeft: z.coerce.number().int().min(0).max(IMAGE_WIDTH).optional(),
  marginRight: z.coerce.number().int().min(0).max(IMAGE_WIDTH).optional(),
  marginTop: z.coerce.number().int().min(0).max(IMAGE_HEIGHT).optional(),
  marginBottom: z.coerce.number().int().min(0).max(IMAGE_HEIGHT).optional(),
  layout: jsonString.optional(),
})
export type UpdateVrmAccountImageSettingRequest = z.infer<typeof UpdateVrmAccountImageSettingRequest>
